import { trackCheckout, trackVerifiedPurchase } from './analytics.service'
import { api } from './http'

/**
 * @typedef {import('../types/openapi').paths['/api/shop/order/create']['post']['requestBody']['content']['application/json']} CreateOrderRequest
 * @typedef {import('../types/openapi').operations['api_shop_discounts_retrieve']['parameters']['query']} DiscountQueryParams
 */

/**
 * @param {CreateOrderRequest} payload
 * @param {string} idempotencyKey
 */
export async function createOrder (payload, idempotencyKey) {
  const response = await api.post('/api/shop/order/create', payload, {
    headers: {
      'Idempotency-Key': idempotencyKey
    }
  })
  trackCheckout(response.data)
  return response
}

export function syncUserCartOrder (payload) {
  return api.post('/api/shop/my/cart-order/sync', payload)
}

export function fetchUserCartOrder (orderId) {
  return api.get(`/api/shop/my/orders/${orderId}`)
}

export async function createShopPayment (payload) {
  const response = await api.post('/api/shop/create-payment-intent', payload)
  trackVerifiedPurchase(response.data)
  return response
}

export async function syncShopPaymentStatus (payload) {
  const response = await api.post('/api/shop/payments/sync', payload)
  trackVerifiedPurchase(response.data)
  return response
}

/**
 * @param {DiscountQueryParams} params
 */
export function fetchDiscountAmount (params) {
  return api.get('/api/shop/discounts', { params })
}
